import { Component } from '@angular/core';

@Component({
  selector: 'app-cgu-loyalty-en',
  templateUrl: './cgu-loyalty-en.component.html',
  styleUrls: ['./cgu-loyalty-en.component.scss'],
  standalone: false,
})
export class CguLoyaltyEnComponent {}
